'use client'

import React, { createContext, useContext } from 'react'

const PageSectionContext = createContext<string | null>(null)

export const usePageSectionContext = () => {
  return useContext(PageSectionContext)
}

interface PageSectionProviderProps {
  sectionName: string
  children: React.ReactNode
}

const PageSectionContextProvider = ({ sectionName, children }: PageSectionProviderProps) => {
  return (
    <PageSectionContext.Provider value={sectionName}>
      {children}
    </PageSectionContext.Provider>
  )
}

export { PageSectionContextProvider }
